'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgUserProfile = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 30 30", height: "30", width: "30", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { d: "M14.976 7a4.235 4.235 0 0 1 2.157 7.881 6.778 6.778 0 0 1 4.616 6.187l.004.238V23H8.2v-1.694a6.78 6.78 0 0 1 4.62-6.426A4.235 4.235 0 0 1 14.976 7zm0 8.47c-3.56 0-5.835 3.295-5.835 5.649v.94h11.67v-.94c0-2.354-2.275-5.648-5.835-5.648zm0-7.529a3.294 3.294 0 1 0 0 6.588 3.294 3.294 0 0 0 0-6.588z", fillRule: "evenodd" }))); };

exports.default = SvgUserProfile;
//# sourceMappingURL=index.js.map
